import { IPagination } from 'app/types/common';

export interface IAddressesState {
  readonly addressesById?: any;
  readonly addressIds?: string[];
  readonly hasSaved?: boolean;
  readonly hasLoaded?: boolean;
  readonly hasFailed?: boolean;
  readonly isLoading?: boolean;
  readonly isSaving?: boolean;
  readonly showAddAddress?: boolean;
  readonly saved?: boolean;
  readonly requestedData?: any;
  readonly backendErrors?: any;
  readonly organisationAddressIds?: string[];
  readonly currentAddressId?: string;
  readonly filterConfig?: any;
  readonly sortConfig?: any;
  readonly pagination?: IPagination;
}

export interface IAddressesSelector extends IAddressesState {
  readonly currentAddress?: any;
  readonly getAddressesFilteredByTagInSelectFormat?: any;
  readonly addressesByIdInSelectFormat?: any;
}

export enum AddressesActionTypes {
  GET_ALL_ADDRESSES_REQUESTED = 'redux-app/addresses/GET_ALL_ADDRESSES_REQUESTED',
  GET_ALL_ADDRESSES_PENDING = 'redux-app/addresses/GET_ALL_ADDRESSES_PENDING',
  GET_ALL_ADDRESSES_SUCCESS = 'redux-app/addresses/GET_ALL_ADDRESSES_SUCCESS',
  GET_ALL_ADDRESSES_FAIL = 'redux-app/addresses/GET_ALL_ADDRESSES_FAIL',
  GET_ADDRESS_REQUESTED = 'redux-app/addresses/GET_ADDRESS_REQUESTED',
  GET_ADDRESS_PENDING = 'redux-app/addresses/GET_ADDRESS_PENDING',
  GET_ADDRESS_SUCCESS = 'redux-app/addresses/GET_ADDRESS_SUCCESS',
  GET_ADDRESS_FAIL = 'redux-app/addresses/GET_ADDRESS_FAIL',
  UPDATE_ADDRESS_REQUESTED = 'redux-app/addresses/UPDATE_ADDRESS_REQUESTED',
  UPDATE_ADDRESS_PENDING = 'redux-app/addresses/UPDATE_ADDRESS_PENDING',
  UPDATE_ADDRESS_SUCCESS = 'redux-app/addresses/UPDATE_ADDRESS_SUCCESS',
  UPDATE_ADDRESS_FAIL = 'redux-app/addresses/UPDATE_ADDRESS_FAIL',
  CREATE_ADDRESS_REQUESTED = 'redux-app/addresses/CREATE_ADDRESS_REQUESTED',
  CREATE_ADDRESS_PENDING = 'redux-app/addresses/CREATE_ADDRESS_PENDING',
  CREATE_ADDRESS_SUCCESS = 'redux-app/addresses/CREATE_ADDRESS_SUCCESS',
  CREATE_ADDRESS_FAIL = 'redux-app/addresses/CREATE_ADDRESS_FAIL',
  DELETE_ADDRESS_REQUESTED = 'redux-app/addresses/DELETE_ADDRESS_REQUESTED',
  DELETE_ADDRESS_PENDING = 'redux-app/addresses/DELETE_ADDRESS_PENDING',
  DELETE_ADDRESS_SUCCESS = 'redux-app/addresses/DELETE_ADDRESS_SUCCESS',
  DELETE_ADDRESS_FAIL = 'redux-app/addresses/DELETE_ADDRESS_FAIL',
  SELECT_ADDRESS_REQUESTED = 'redux-app/addresses/SELECT_ADDRESS_REQUESTED'
}

export default null;
